import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { FillScreen } from '@/components/Layout';
import { PackagePatternConfigTable } from '@/features/operation-package-config-new/PackagePatternConfig';
import useDocumentTitle from '@/hooks/useDocumentTitle';

export const Route = createFileRoute('/_staff/it-operation-core/_root/config/')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  useDocumentTitle('Operation Package | Configs');
  const navigate = useNavigate();

  const handlePatternRowClick = (patternId: string) => {
    navigate({
      to: '/it-operation-core/config/$patternId',
      params: { patternId },
    });
  };

  return (
    <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <PackagePatternConfigTable
        ownerProduct="IT_OPERATION_CORE"
        handlePatternRowClick={handlePatternRowClick}
      />
    </FillScreen>
  );
}
